/**
 * 获取任务名称
 */
export const TRACK_EVENT_GET_TASK_NAME = '获取任务名称';

/**
 * 设置任务名称
 */
export const TRACK_EVENT_SET_TASK_NAME = '设置任务名称';

/**
 * 预览和导出
 */
export const TRACK_EVENT_PREVIEW_AND_EXPORT = '预览和导出';

/**
 * 进入翻译初始界面
 */
export const TRACK_EVENT_ENTER_TRANSLATION_INITIAL = '进入翻译初始界面';

/**
 * 离开翻译初始界面
 */
export const TRACK_EVENT_LEAVE_TRANSLATION_INITIAL = '离开翻译初始界面';

/**
 * 进入翻译结果界面
 */
export const TRACK_EVENT_ENTER_TRANSLATION_RESULT = '进入翻译结果界面';

/**
 * 离开翻译结果界面
 */
export const TRACK_EVENT_LEAVE_TRANSLATION_RESULT = '离开翻译结果界面';

/**
 * 进入翻译预览界面
 */
export const TRACK_EVENT_ENTER_TRANSLATION_PREVIEW = '进入翻译预览界面';

/**
 * 离开翻译预览界面
 */
export const TRACK_EVENT_LEAVE_TRANSLATION_PREVIEW = '离开翻译预览界面';

/**
 * 进入翻译导出界面
 */
export const TRACK_EVENT_ENTER_TRANSLATION_EXPORT = '进入翻译导出步骤';

/**
 * 获取推荐词
 */
export const TRACK_EVENT_GET_RECOMMEND_TRANSLATE_KEYWORD = '获取推荐词';

/**
 * 获取推荐词失败
 */
export const TRACK_EVENT_GET_RECOMMEND_TRANSLATE_KEYWORD_FAILED = '获取推荐词失败';

/**
 * 访问首页
 */
export const TRACK_EVENT_ENTER_HOME = 'homepage_view';

/**
 * 点击首页Banner (还未实现)
 */
export const TRACK_EVENT_CLICK_HOME_BANNER = 'homepage_banner_click';

/**
 * 首页OAR创建任务
 */
export const TRACK_EVENT_CREATE_OAR_HOME = 'homepage_oar_create';

/**
 * 首页说明书创建任务
 */
export const TRACK_EVENT_CREATE_SPECIFICATION_HOME = 'homepage_specification_create';

/**
 * 首页交底书创建任务
 */
export const TRACK_EVENT_CREATE_DISCLOSURE_HOME = 'homepage_disclosure_create';

/**
 * 首页翻译创建任务
 */
export const TRACK_EVENT_CREATE_TRANSLATION_HOME = 'homepage_translation_create';

/**
 * 首页查新预告
 */
export const TRACK_EVENT_CREATE_NOVELTY_FORECAST_HOME = 'homepage_novelty_forecast_click';

/**
 * 首页用户建议
 */
export const TRACK_EVENT_USER_SUGGESTION_HOME = 'homepage_user_suggestion_click';

/**
 * 首页查看近期工作 (不知道怎么实现)
 */
export const TRACK_EVENT_VIEW_RECENT_WORK_HOME = 'homepage_view_recent_work_click';

/**
 * 首页近期工作全部 (还没实现)
 */
export const TRACK_EVENT_VIEW_RECENT_WORK_ALL_HOME = 'homepage_recent_work_all_click';

/**
 * 侧边栏翻译创建任务
 */
export const TRACK_EVENT_CREATE_TRANSLATION_SIDEBAR = 'sidebar_translation_create';

/**
 * 侧边栏交底书创建任务
 */
export const TRACK_EVENT_CREATE_DISCLOSURE_SIDEBAR = 'sidebar_disclosure_create';

/**
 * 侧边栏说明书创建任务
 */
export const TRACK_EVENT_CREATE_SPECIFICATION_SIDEBAR = 'sidebar_specification_create';

/**
 * 侧边栏查新预告
 */
export const TRACK_EVENT_CREATE_NOVELTY_FORECAST_SIDEBAR = 'sidebar_novelty_forecast_click';

/**
 * 侧边栏近期工作
 */
export const TRACK_EVENT_VIEW_RECENT_WORK_SIDEBAR = 'sidebar_recent_work_click';

/**
 * 侧边栏近期工作全部
 */
export const TRACK_EVENT_VIEW_RECENT_WORK_ALL_SIDEBAR = 'sidebar_recent_work_all_click';

/**
 * 侧边栏积分点击 （未实现）
 */
export const TRACK_EVENT_VIEW_CREDITS_SIDEBAR = 'sidebar_credits_click';

/**
 * 侧边栏通知（未实现）
 */
export const TRACK_EVENT_VIEW_NOTIFICATION_SIDEBAR = 'sidebar_notification_click';

/**
 * 侧边栏设置 （未实现）
 */
export const TRACK_EVENT_VIEW_SETTINGS_SIDEBAR = 'sidebar_settings_click';

/**
 * 侧边栏设置组织 （未实现）
 */
export const TRACK_EVENT_VIEW_SETTINGS_ORGANIZATION_SIDEBAR = 'settings_organization_click';

/**
 * 侧边栏设置账号 （未实现）
 */
export const TRACK_EVENT_VIEW_SETTINGS_ACCOUNT_SIDEBAR = 'settings_account_click';

/**
 * 侧边栏设置团队 （未实现）
 */
export const TRACK_EVENT_VIEW_SETTINGS_TEAM_SIDEBAR = 'settings_team_click';

/**
 * 侧边栏设置任务 （未实现）
 */
export const TRACK_EVENT_VIEW_SETTINGS_TASKS_SIDEBAR = 'settings_tasks_click';

/**
 * 侧边栏设置语言 （未实现）
 */
export const TRACK_EVENT_VIEW_SETTINGS_LANGUAGE_SIDEBAR = 'settings_language_click';

/**
 * 侧边栏设置登出 （未实现）
 */
export const TRACK_EVENT_VIEW_SETTINGS_LOGOUT_SIDEBAR = 'settings_logout_click';

/**
 * 任务 说明书tab
 */
export const TRACK_EVENT_TASK_SPECIFICATION_TAB_CLICK = 'task_specification_tab_click';

/**
 * 任务 交底书tab
 */
export const TRACK_EVENT_TASK_DISCLOSURE_TAB_CLICK = 'task_disclosure_tab_click';

/**
 * 任务 翻译tab
 */
export const TRACK_EVENT_TASK_TRANSLATION_TAB_CLICK = 'task_translation_tab_click';

/**
 * 任务 查看
 */
export const TRACK_EVENT_TASK_VIEW_DETAIL_CLICK = 'task_view_detail_click';

/**
 * 任务 下载
 */
export const TRACK_EVENT_TASK_DOWNLOAD_CLICK = 'translation_download_click';

/**
 * 翻译 打开术语表
 */
export const TRACK_EVENT_TRANSLATION_GLOSSARY_CLICK = 'translation_glossary_click';

/**
 * 翻译 新增术语
 */
export const TRACK_EVENT_TRANSLATION_GLOSSARY_ADD_CLICK = 'translation_glossary_add_click';

/**
 * 翻译 导入术语
 */
export const TRACK_EVENT_TRANSLATION_GLOSSARY_IMPORT_CLICK = 'translation_glossary_import_click';

/**
 * 翻译 编辑术语 (无法实现)
 */
export const TRACK_EVENT_TRANSLATION_GLOSSARY_EDIT_CLICK = 'translation_glossary_edit_click';

/**
 * 翻译 删除术语
 */
export const TRACK_EVENT_TRANSLATION_GLOSSARY_DELETE_CLICK = 'translation_glossary_delete_click';

/**
 * 翻译 保存术语
 */
export const TRACK_EVENT_TRANSLATION_GLOSSARY_SUBMIT_CLICK = 'translation_glossary_submit_click';

/**
 * 翻译 选择样例
 */
export const TRACK_EVENT_TRANSLATION_SELECT_SAMPLE_CLICK = 'translation_select_sample_click';

/**
 * 翻译 选择语言
 */
export const TRACK_EVENT_TRANSLATION_SELECT_LANGUAGE = 'translation_select_language';

/**
 * 翻译 开始翻译
 */
export const TRACK_EVENT_TRANSLATION_START_CLICK = 'translation_start_click';

/**
 * 翻译 修改标题 (通用编辑头)
 */
export const TRACK_EVENT_EDIT_TITLE = 'translation_edit_title';

/**
 * 翻译 修改原文重译
 */
export const TRACK_EVENT_TRANSLATION_RETRANSLATE_ORIGINAL_CLICK = 'translation_retranslate_original_click';

/**
 * 翻译 编辑译文
 */
export const TRACK_EVENT_TRANSLATION_EDIT_TRANSLATION_CLICK = 'translation_edit_translation_click';

/**
 * 翻译 译文重译
 */
export const TRACK_EVENT_TRANSLATION_RETRANSLATE_TRANSLATION_CLICK = 'translation_retranslate_translation_click';

/**
 * 翻译 创建新任务
 */
export const TRACK_EVENT_TRANSLATION_START_NEW_TASK_CLICK = 'translation_start_new_task_click';

/**
 * 翻译 预览全文
 */
export const TRACK_EVENT_TRANSLATION_PREVIEW_CLICK = 'translation_preview_click';

/**
 * 翻译 导出全文
 */
export const TRACK_EVENT_TRANSLATION_EXPORT_CLICK = 'translation_export_click';

/**
 * 交底书 选择样例
 */
export const TRACK_EVENT_DISCLOSURE_SELECT_SAMPLE_CLICK = 'disclosure_select_sample_click';

/**
 * 交底书 开始生成
 */
export const TRACK_EVENT_DISCLOSURE_GENERATE_CLICK = 'disclosure_generate_click';

/**
 * 交底书 编辑要素 重新生成
 */
export const TRACK_EVENT_DISCLOSURE_EDIT_INTERPRETATION_CLICK = 'disclosure_edit_interpretation_click';

/**
 * 交底书 查看引用 （未实现）
 */
export const TRACK_EVENT_DISCLOSURE_VIEW_REFERENCES_CLICK = 'disclosure_view_references_click';

/**
 * 交底书 编辑保存
 */
export const TRACK_EVENT_DISCLOSURE_EDIT_SUBMIT_CLICK = 'disclosure_edit_submit_click';

/**
 * 交底书 AI优化 (未实现)
 */
export const TRACK_EVENT_DISCLOSURE_AI_OPTIMIZE_CLICK = 'disclosure_ai_optimize_click';

/**
 * 交底书 导出全文
 */
export const TRACK_EVENT_DISCLOSURE_EXPORT_CLICK = 'disclosure_export_click';

/**
 * 交底书 创建新任务
 */
export const TRACK_EVENT_DISCLOSURE_START_NEW_TASK_CLICK = 'disclosure_start_new_task_click';

/**
 * 侧边点击事件
 */
export const TRACK_EVENT_CREATE_AGENT_SIDEBAR = 'sidebar_create_agent_click';

/**
 * 说明书
 * @description 说明书首页
 */
export const TRACK_EVENT_SPECIFICATION_HOMEPAGE_VIEW = 'specification_homepage_view';

/**
 * 说明书
 * @description 样例使用人数，需要传入当前点击的样例类型
 */
export const TRACK_EVENT_SPECIFICATION_HOMEPAGE_SAMPLE = 'specification_homepage_sample';

/**
 * 说明书
 * @description 创建页面的生成按钮
 */
export const TRACK_EVENT_SPECIFICATION_HOMEPAGE_GENERATE = 'specification_homepage_generate';

/**
 * 说明书
 * @description 美国专利说明书生成
 */
export const TRACK_EVENT_SPECIFICATION_US_GENERATE = 'specification_us_generate';

/**
 * 说明书
 * @description 中国专利说明书生成
 */
export const TRACK_EVENT_SPECIFICATION_CN_GENERATE = 'specification_cn_generate';

/**
 * 说明书
 * @description 欧洲专利说明书生成
 */
export const TRACK_EVENT_SPECIFICATION_EU_GENERATE = 'specification_eu_generate';

/**
 * 说明书
 * @description 确认交底书的重新生成
 */
export const TRACK_EVENT_SPECIFICATION_DISCLOSURE_REGENERATE = 'specification_disclosure_regenerate';

/**
 * 说明书
 * @description 进入权要界面次数，确认交底书的下一步按钮
 */
export const TRACK_EVENT_SPECIFICATION_DISCLOSURE_GENERATE = 'specification_disclosure_generate';

/**
 * 说明书
 * @description 确认权利要求的重新生成
 */
export const TRACK_EVENT_SPECIFICATION_CLAIMS_REGENERATE = 'specification_claims_regenerate';

/**
 * 说明书
 * @description 权利要求操作，编辑、拖动权利要求，增删改拖动权利要求的特征短语
 */
export const TRACK_EVENT_SPECIFICATION_CLAIMS_FEATURES = 'specification_claims_features';

/**
 * 说明书
 * @description 术语调整操作，新增、删除术语
 */
export const TRACK_EVENT_SPECIFICATION_CLAIMS_TERMS = 'specification_claims_terms';

/**
 * 说明书
 * @description 正式生成，确认权利要求的生成按钮
 */
export const TRACK_EVENT_SPECIFICATION_CLAIMS_GENERATE = 'specification_claims_generate';

/**
 * 说明书
 * @description 生成页面，手动停止生成
 * @description 需要传参当前处理的段落
 */
export const TRACK_EVENT_SPECIFICATION_GENERATION_STOP = 'specification_generation_stop';

/**
 * 说明书
 * @description 生成页面，生成失败和手动停止时的重新生成按钮
 */
export const TRACK_EVENT_SPECIFICATION_GENERATION_REGENERATE = 'specification_generation_regenerate';

/**
 * 说明书
 * @description 优化
 * @description 需要传参当前处理的段落
 */
export const TRACK_EVENT_SPECIFICATION_GENERATION_REWRITE = 'specification_generation_rewrite';

/**
 * 说明书
 * @description 扩写
 * @description 需要传参当前处理的段落
 */
export const TRACK_EVENT_SPECIFICATION_GENERATION_LONGER = 'specification_generation_longer';

/**
 * 说明书
 * @description 缩写
 * @description 需要传参当前处理的段落
 */
export const TRACK_EVENT_SPECIFICATION_GENERATION_SHORTER = 'specification_generation_shorter';

/**
 * 说明书
 * @description 续写、扩展实施例
 * @description 需要传参当前处理的段落
 */
export const TRACK_EVENT_SPECIFICATION_GENERATION_EXPAND = 'specification_generation_expand';

/**
 * 免费版使用量超限弹出. 从eureka中copy过来的的事件名字
 */
export const AIR_USAGE_UPGRADE_SHOW = 'AIR-usage-upgrade-show';

/**
 * 说明书
 * @description 导出次数
 */
export const TRACK_EVENT_SPECIFICATION_GENERATION_EXPORT = 'specification_generation_export';

/**
 * 说明书
 * @description 生成页 AI 助手调整内容弹窗的重新生成
 */
export const TRACK_EVENT_SPECIFICATION_MODIFY_REGENERATE = 'specification_modify_regenerate';


/**
 * 用户在首页“撰写”模块点击了“上传交底书”按钮
 */
export const TRACK_EVENT_SPECIFICATION_DISCLOSURE_UPLOAD = 'specification_disclosure_upload';

/**
 * 用户在首页“撰写”模块点击了“上传权利要求”按钮
 */
export const TRACK_EVENT_SPECIFICATION_CLAIMS_UPLOAD = 'specification_claims_upload';

/**
 * 查新
 * @description 记录进入功能的动作，通过 user_id 聚合分析用户数、频次
 */
export const TRACK_EVENT_NOVELTY_CHECK_ENTER = 'enter_novelty_check';

/**
 * 查新
 * @description 用户在任何输入框开始输入内容时触发
 */
export const TRACK_EVENT_NOVELTY_CHECK_USER_INPUT = 'user_input';

/**
 * 查新
 * @description 用户成功上传文档到系统时记录 (还未实现)
 */
export const TRACK_EVENT_NOVELTY_CHECK_UPLOAD_DOCUMENT = 'upload_document';

/**
 * 查新
 * @description 用户从样例库中选择特定样例时触发
 */
export const TRACK_EVENT_NOVELTY_CHECK_SELECT_EXAMPLE = 'select_example';

/**
 * 查新
 * @description 用户点击开始查新按钮，启动查新流程
 */
export const TRACK_EVENT_NOVELTY_CHECK_LAUNCH = 'launch_novelty_check';

/**
 * 查新
 * @description 系统在语言检查过程中发现错误或不符合规范的内容时记录 (还未实现)
 */
export const TRACK_EVENT_NOVELTY_CHECK_LAUNCH_ERROR = 'lang_check_error';

/**
 * 查新
 * @description 用户主动中止技术特征识别流程时触发
 */
export const TRACK_EVENT_NOVELTY_CHECK_ABORT_TECH_FEATURE = 'abort_tech_feature';

/**
 * 查新
 * @description 用户确认系统识别的技术特征无误时记录
 */
export const TRACK_EVENT_NOVELTY_CHECK_CONFIRM_TECH_FEATURE = 'confirm_tech_feature';

/**
 * 查新
 * @description 用户提前终止深度思考过程并生成报告时触发
 */
export const TRACK_EVENT_NOVELTY_CHECK_DEEP_THINKING_STOP = 'deep_thinking_stop';

/**
 * 查新
 * @description 用户通过输入专利号手动添加对比文献时记录
 */
export const TRACK_EVENT_NOVELTY_CHECK_ADD_REF_PATENT = 'add_ref_patent';

/**
 * 查新
 * @description 保存到工作空间
 */
export const TRACK_EVENT_NOVELTY_CHECK_SAVE_TO_WORKSPACE = 'save_to_workspace';

/**
 * 查新
 * @description 特征对比返回
 */
export const TRACK_EVENT_NOVELTY_CHECK_COMPARE_TABLE_BACK = 'compare_table_back';

/**
 * 查新
 * @description 用户在检索结果列表中点击查看特定专利的详细信息时触发
 */
export const TRACK_EVENT_NOVELTY_CHECK_VIEW_PATENT_DETAIL = 'view_patent_detail';

/**
 * 查新
 * @description 用户在技术特征对比表中点击搜索公知证据按钮
 */
export const TRACK_EVENT_NOVELTY_CHECK_SEARCH_COMMON_EVIDENCE = 'search_common_evidence';

/**
 * 查新
 * @description 用户切换技术特征对比表中"显示公知证据"开关
 */
export const TRACK_EVENT_NOVELTY_CHECK_TOGGLE_COMMON_EVIDENCE = 'toggle_common_evidence';

/**
 * 查新
 * @description 用户点击加载更多检索结果时记录
 */
export const TRACK_EVENT_NOVELTY_CHECK_SHOW_MORE_RESULTS = 'show_more_results';

/**
 * 查新
 * @description 用户从检索结果中选择文献作为对比文献时触发
 */
export const TRACK_EVENT_NOVELTY_CHECK_SEARCH_RESULT_SELECT = 'search_result_select';

/**
 * 查新
 * @description 用户对对比文献列表进行编辑操作（如删除、排序）时记录 (还未实现)
 */
export const TRACK_EVENT_NOVELTY_CHECK_COMPARISON_LIST_EDIT = 'comparisonlist_edit';

/**
 * 查新
 * @description 用户点击生成查新报告并成功创建时触发
 */
export const TRACK_EVENT_NOVELTY_CHECK_CREATE_REPORT = 'create_report';

/**
 * 查新
 * @description 用户点击展开“展开 Agent 过程”
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_EXPAND = 'noveltyreport_expand';

/**
 * 查新
 * @description 用户点击编辑技术方案
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_EDIT_TECH_PROPOSAL = 'noveltyreport_edit_tech_proposal';

/**
 * 查新
 * @description 用户取消选择技术特征
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_UNSELECT_FEATURE = 'noveltyreport_unselect_feature';

/**
 * 查新
 * @description 用户新增技术特征
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_ADD_FEATURE = 'noveltyreport_add_feature';

/**
 * 查新
 * @description 添加、删除关键词、关键词组、分类号、检索要素
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_UPDATE_RETRIEVAL_ELEMENTS = 'noveltyreport_update_retrieval_elements';

/**
 * 查新
 * @description 同组合并
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_FAMILY_GROUP = 'noveltyreport_family_group';

/**
 * 查新
 * @description 老设置入口变更设置时触发，用于判断设置入口使用情况
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_SETTING_CHANGE = 'noveltyreport_setting_change';

/**
 * 查新
 * @description 用户将查新报告导出为指定格式（如PDF/DOC）时触发 (还未实现)
 */
export const TRACK_EVENT_NOVELTY_CHECK_REPORT_EXPORT = 'novelty_report_export';

/**
 * 防侵权检索
 * @description 记录进入功能的动作，通过 user_id 聚合分析用户数、频次
 */
export const TRACK_EVENT_FTO_REPORT_ENTER = 'enter_fto';

/**
 * 防侵权检索
 * @description 用户选择或修改 受理局、简单法律状态、仅包含企业、排除企业、开始时间 过滤项
 */
export const TRACK_EVENT_FTO_REPORT_SET_ADVANCED_SETTINGS = 'set_advanced_settings';

/**
 * 防侵权检索
 * @description 用户在任何输入框开始输入内容时触发
 */
export const TRACK_EVENT_FTO_REPORT_USER_INPUT = 'input_tech_solution';

/**
 * 防侵权检索
 * @description 用户从样例库中选择特定样例时触发（产品未要求）
 */
export const TRACK_EVENT_FTO_REPORT_SELECT_EXAMPLE = 'fto_report_select_example';

/**
 * 防侵权检索
 * @description 用户点击开始查新按钮，启动FTO流程
 */
export const TRACK_EVENT_FTO_REPORT_LAUNCH = 'launch_fto_agent';

/**
 * 防侵权检索
 * @description 用户在输入页点击“开始”
 */
export const TRACK_EVENT_FTO_REPORT_INPUT_SUBMIT = 'input_submit';

/**
 * 防侵权检索
 * @description 用户主动中止技术特征识别流程时触发（产品未要求）
 */
export const TRACK_EVENT_FTO_REPORT_ABORT_TECH_FEATURE = 'fto_report_abort_tech_feature';

/**
 * 防侵权检索
 * @description 用户新增、修改技术特征，或修改技术方案
 */
export const TRACK_EVENT_FTO_REPORT_EDIT_TECH_FEATURE = 'edit_tech_feature';

/**
 * 防侵权检索
 * @description 用户确认系统识别的技术特征无误时记录
 */
export const TRACK_EVENT_FTO_REPORT_CONFIRM_TECH_FEATURE = 'confirm_tech_feature';

/**
 * 防侵权检索
 * @description 用户提前终止深度思考过程并生成报告时触发（产品未要求）
 */
export const TRACK_EVENT_FTO_REPORT_DEEP_THINKING_STOP = 'fto_report_deep_thinking_stop';

/**
 * 防侵权检索
 * @description 用户查看技术特征与对比文献的比较结果。
 */
export const TRACK_EVENT_FTO_REPORT_VIEW_TECH_COMPARE = 'view_tech_compare';

/**
 * 防侵权检索
 * @description 用户点击添加专利按钮
 */
export const TRACK_EVENT_FTO_REPORT_ADD_PATENT = 'click_add_patent';

/**
 * 防侵权检索
 * @description 用户通过输入专利号手动添加对比文献时记录
 */
export const TRACK_EVENT_FTO_REPORT_ADD_REF_PATENT = 'add_reference';

/**
 * 防侵权检索
 * @description 用户编辑技术特征对比表格。
 */
export const TRACK_EVENT_FTO_REPORT_EDIT_FEATURE_TABLE = 'edit_feature_table';

/**
 * 防侵权检索
 * @description 用户在检索结果列表中点击查看特定专利的详细信息时触发（产品未要求）
 */
export const TRACK_EVENT_FTO_REPORT_VIEW_PATENT_DETAIL = 'fto_report_view_patent_detail';

/**
 * 防侵权检索
 * @description 用户点击加载更多检索结果时记录（产品未要求）
 */
export const TRACK_EVENT_FTO_REPORT_SHOW_MORE_RESULTS = 'fto_report_show_more_results';

/**
 * 防侵权检索
 * @description 用户从检索结果中选择文献作为对比文献时触发
 */
export const TRACK_EVENT_FTO_REPORT_SEARCH_RESULT_SELECT = 'select_related_patent';

/**
 * 防侵权检索
 * @description 用户点击生成FTO报告并成功创建时触发
 */
export const TRACK_EVENT_FTO_REPORT_CREATE_REPORT = 'create_fto_report';

/**
 * 防侵权检索
 * @description 用户点击展开“展开 Agent 过程”（产品未要求）
 */
export const TRACK_EVENT_FTO_REPORT_REPORT_EXPAND = 'fto_report_report_expand';

/**
 * 防侵权检索
 * @description 用户将FTO报告导出为指定格式（如PDF/DOC）时触发
 */
export const TRACK_EVENT_FTO_REPORT_REPORT_EXPORT = 'export_fto_report';

/**
 * 防侵权检索
 * @description 用户创建新的 FTO 任务。
 */
export const TRACK_EVENT_FTO_REPORT_CREATE_NEW_TASK = 'create_new_fto_task';

/**
 * 防侵权检索
 * @description AI 成功生成方案并加载确认页
 */
export const TRACK_EVENT_FTO_REPORT_PROPOSAL_GENERATED = 'proposal_generated';

/**
 * 防侵权检索
 * @description 用户在特征提取确认页对表格进行操作
 */
export const TRACK_EVENT_FTO_REPORT_FEATURE_CONFIRM_ACTION = 'feature_confirm_action';

/**
 * 防侵权检索
 * @description 统计用户修改技术特征的频次，评估 AI 特征提取的准确性。
 */
export const TRACK_EVENT_FTO_REPORT_FEATURE_EDIT_ACTION = 'feature_edit_action';

/**
 * 防侵权检索
 * @description 用户点击“确认并运行”
 */
export const TRACK_EVENT_FTO_REPORT_CONFIRM_RUN = 'confirm_run';

/**
 * 防侵权检索
 * @description 用户点击“保存并运行”
 */
export const TRACK_EVENT_FTO_REPORT_EDIT_SAVE = 'edit_save';

/**
 * 防侵权检索
 * @description 统计用户纠正 AI 分类的次数（例如 AI 说保留，用户改排除）。
 */
export const TRACK_EVENT_FTO_REPORT_PATENT_RECLASSIFY = 'patent_reclassify';

/**
 * 防侵权检索
 * @description 统计用户点击编辑按钮
 */
export const TRACK_EVENT_FTO_REPORT_EDIT = 'click_edit';

/**
 * 防侵权检索
 * @description 统计用户点击从工作空间导入
 */
export const TRACK_EVENT_FTO_REPORT_IMPORT_FROM_WORKSPACE = 'click_import_from_workspace';

/**
 * 用户在首页点击了“体验更多Agent”的入口（按钮/链接）I. I.
 */
export const TRACK_EVENT_HOMEPAGE_MORE_AGENTS_TOGGLE = 'homepage_more_agents_toggle';
/**
 * 用户在“更多Agent”页点击了“其他Agent”入口
 */
export const TRACK_EVENT_HOMEPAGE_MORE_AGENTS_CLICK = 'homepage_more_agents_click';
/**
 * 用户在套餐对比页（或特定套餐页）点击了“升级Pro”按钮
 */
export const TRACK_EVENT_PLANS_UPGRADE_PRO_CLICK = 'plans_upgrade_pro_click';
/**
 * 用户在套餐对比页（或特定套餐页）点击了“联系我们”按钮
 */
export const TRACK_EVENT_PLANS_CONTACT_SALES_CLICK = 'plans_contact_sales_click';
/**
 * 用户在内嵌的Hubspot表单中点击了"确认提交"按钮
 */
export const TRACK_EVENT_HUBSPOT_FORM_SUBMIT = 'hubspot_form_submit';
/**
 * 任务分享菜单点击
 */
export const TRACK_EVENT_TASK_SHARE_MENU_CLICK = 'task_share_menu_click';
/**
 * 任务分享拷贝链接点击
 */
export const TRACK_EVENT_TASK_SHARE_COPY_LINK_CLICK = 'task_share_copy_link_click';

/**
 * 外观FTO
 * @description 记录进入外观FTO功能入口页
 */
export const TRACK_EVENT_DESIGN_FTO_ENTER = 'enter_design_fto';

/**
 * 外观FTO
 * @description 用户点击示例图片
 */
export const TRACK_EVENT_DESIGN_FTO_SELECT_EXAMPLE = 'design_fto_select_example';

/**
 * 外观FTO
 * @description 用户成功上传图片
 */
export const TRACK_EVENT_DESIGN_FTO_UPLOAD_IMAGE = 'design_fto_upload_image';

/**
 * 外观FTO
 * @description 用户点击开始检索按钮，启动外观FTO流程
 */
export const TRACK_EVENT_DESIGN_FTO_LAUNCH = 'launch_design_fto';

/**
 * 外观FTO
 * @description 记录进入外观FTO流程页面
 */
export const TRACK_EVENT_DESIGN_FTO_ENTER_FLOW = 'enter_design_fto_flow';

/**
 * 外观FTO
 * @description 用户点击专利号查看专利详情
 */
export const TRACK_EVENT_DESIGN_FTO_VIEW_PATENT_DETAIL = 'design_fto_view_patent';

/**
 * 外观FTO
 * @description 用户查看特征对比表
 */
export const TRACK_EVENT_DESIGN_FTO_VIEW_COMPARISON = 'design_fto_view_comparison';

/**
 * 外观FTO
 * @description 用户点击分享按钮
 */
export const TRACK_EVENT_DESIGN_FTO_SHARE = 'design_fto_share';

/**
 * 外观FTO
 * @description 用户复制分享链接
 */
export const TRACK_EVENT_DESIGN_FTO_COPY_LINK = 'design_fto_copy_link';

/**
 * 外观FTO
 * @description 导出报告
 */
export const TRACK_EVENT_DESIGN_FTO_EXPORT_REPORT = 'design_fto_export_report';
/**
 * 升级触发
 */
export const TRACK_EVENT_UPGRADE_TRIGGER = 'upgrade_trigger';
/**
 * 登录注册弹窗触发
 */
export const TRACK_EVENT_REGISTER_EXPOSURE = 'register_exposure';
/**
 * 用户点击"注册"
 */
export const TRACK_EVENT_REGISTER_CLICK = 'register_click';
/**
 * 用户关闭注册框
 */
export const TRACK_EVENT_REGISTER_CLOSE = 'register_close';

/**
 * 定价页面浏览
 */
export const TRACK_EVENT_PRICING_PAGE_VIEW = 'pricing_page_view';

/**
 * 点击订阅Pro
 */
export const TRACK_EVENT_CLICK_SUBSCRIBE_PRO = 'click_subscribe_pro';
export const TRACK_EVENT_CLICK_SUBSCRIBE_ENTERPRISE= 'click_subscribe_enterprise';
export const TRACK_EVENT_CLICK_SUBSCRIBE_API= 'click_subscribe_api';
export const TRACK_EVENT_DESIGN_FTO_COPY_LINK_2 = 'result_share_link';

/**
 * 外观FTO
 * @description 用户点击查看步骤结果
 */
export const TRACK_EVENT_DESIGN_FTO_VIEW_RESULT = 'result_view_button';
/**
 * 以上的写法逐渐废弃,使用这个SOURCE_TYPE
 */
export const SOURCE_TYPE = {
    agent_home: 'agent_home',
};
